module.exports = __webpack_public_path__ + "static/img/4578_phase_function_Paper_PointsHejduk_Prediction.84cb2e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4578_phase_function_Paper_PointsHejduk_Prediction.png
// module id = EXmz
// module chunks = 0